module.exports = __webpack_public_path__ + "img/vin.973420eb.jpg";